import type {PhosphorIconAsset} from "@khanacademy/wonder-blocks-icon";
import type {Reaction} from "@khan/guide-types";

import thumbsDown from "@phosphor-icons/core/bold/thumbs-down-bold.svg";
import thumbsUp from "@phosphor-icons/core/bold/thumbs-up-bold.svg";

const emojiForReaction = (reaction: Reaction): PhosphorIconAsset | null => {
    switch (reaction) {
        case "thumbs-up":
            return thumbsUp;

        case "thumbs-down":
            return thumbsDown;

        default:
            return null;
    }
};

export default emojiForReaction;
